import React from 'react';
import { cx } from './toneStyles';

/**
 * Avatar — initial in a coloured circle (baby chip, caregiver rows).
 *
 * Props
 *   name   used for the initial and the accessible name
 *   index  picks the colour deterministically (falls back to a hash of the name)
 *   size   'sm' (24px) | 'md' (36px) | 'lg' (48px)
 */
const PALETTE = [
  'bg-primary-500 text-white',
  'bg-accent-500 text-white',
  'bg-warm-500 text-white',
  'bg-success-600 text-white',
  'bg-event-sleep text-white',
  'bg-event-pump text-white',
];
const SIZES = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-9 h-9 text-sm',
  lg: 'w-12 h-12 text-base',
};

function hashName(name = '') {
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return h;
}

export default function Avatar({ name = '', index, size = 'md', className = '' }) {
  const idx = Number.isInteger(index) && index >= 0 ? index : hashName(name);
  const colour = PALETTE[idx % PALETTE.length];
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';

  return (
    <span
      role="img"
      aria-label={name || 'Baby'}
      className={cx(
        'inline-flex items-center justify-center rounded-full font-bold flex-shrink-0 select-none',
        SIZES[size] || SIZES.md,
        colour,
        className
      )}
    >
      <span aria-hidden="true">{initial}</span>
    </span>
  );
}
